import { Component, OnInit } from '@angular/core';
import { CredentialsService } from 'src/app/services/credentials.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-whatsapp-link',
  templateUrl: './whatsapp-link.component.html',
  styleUrls: ['./whatsapp-link.component.scss']
})
export class WhatsappLinkComponent implements OnInit {

  public whatsappLink: string = '';
  public hasWhatsappLink: boolean = false
  public webview: boolean = false
  constructor(private credentialsService: CredentialsService) { }

  ngOnInit(): void {
    const userAgent = navigator.userAgent.toLowerCase();    
    if (
      userAgent.indexOf("wv") >-1 || userAgent.indexOf("webview") >-1
    ) {
      this.webview = true;
    }
    

    this.hasWhatsappLink = environment.enableWhatsappLink
    if (this.hasWhatsappLink == true) {
      this.credentialsService.getWhatsappLink().subscribe((res: any) => {
        if(res.link) {
          this.whatsappLink = res.link;
        }
      });
    }
  }

}
